/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../../utils/useForm';

const useLenderOnboardingStepThree = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: '',
        fields: [
          {
            title: 'Tax Impound Shortage',
            description:
              'How should Pixel Servicing handle tax impound shortage at the time taxes are due?',
            name: 'pref_tax_impound_shortage',
            type: 'radio',
            options: [
              {
                label:
                  'Notify lender in advance. Lender will decide whether or not to advance funds at that time.',
                value: 'lender_notify',
              },
              {
                label:
                  'Withdraw automatically from lender’s bank account to advance and cover shortage.',
                value: 'lender_advance',
              },
              {
                label: 'Do nothing. Taxes will NOT be paid.',
                value: 'do_nothing',
              },
            ],
            required: true,
          },
          {
            title: 'Insurance Cancellation',
            description:
              'How should Pixel Servicing handle insufficent insurance coverage?',
            name: 'pref_insurance_cancel',
            type: 'radio',
            options: [
              {
                label:
                  'Force place automatically. Payment for forced policy will be paid first out of insurance impound (if any). Servicer will advance funds to pay remainder of forced policy balance. Servicer will demand payment from borrower, but lender is liable for borrower non-payment.',
                value: 'force_place',
              },
              {
                label: 'Do nothing. Insurance will NOT be paid.',
                value: 'do_nothing',
              },
            ],
            required: true,
          },
          {
            title: 'HOA Impound Shortage',
            description:
              'How should Pixel Servicing handle HOA impound shortage at the time HOA fees are due?',
            name: 'pref_hoa_impound_shortage',
            type: 'radio',
            options: [
              {
                label:
                  'Notify lender in advance. Lender will decide whether or not to advance funds at that time.',
                value: 'lender_notify',
              },
              {
                label:
                  'Withdraw automatically from lender’s bank account to advance and cover shortage.',
                value: 'lender_advance',
              },
              {
                label: 'Do nothing. HOA fees will NOT be paid.',
                value: 'do_nothing',
              },
            ],
            required: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values, onlyValuesPresentInForm: true });
};

export default useLenderOnboardingStepThree;
